/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import GrantsIcon from 'icons/GrantsIcon';

const messages = defineMessages({
  title: {id: 'navigation.grants'},
});

const GrantsItem = () => (
  <RouteLinkItem
    iconBefore={GrantsIcon}
    route="midas/grants/grants"
    title={messages.title}
  />
);

export default GrantsItem;
